import { Events } from 'global/constants';
import orderHistoryAddProductsSelectAll from './orderHistoryAddProducts/orderHistoryAddProductsSelectAll';
import OrderHistoryAddProductsObservable from './orderHistoryAddProducts/OrderHistoryAddProductsObservable';
import OrderHistoryAddToListBtn from './orderHistoryAddToList/OrderHistoryAddToListBtn';
import OrderHistoryAddProductsValidator from './orderHistoryAddProducts/OrderHistoryAddProductsValidator';
import orderHistoryRequestAndDisplayModal from './orderHistoryAddToList/orderHistoryRequestAndDisplayModal';
import orderHistoryAddToListSubmit from './orderHistoryAddToList/orderHistoryAddToListSubmit';

const { events } = window.od;

if (document.querySelector('[data-id="orderHistoryAddToListPage"]')) {
	// Add to list page code
	new OrderHistoryAddProductsObservable();
	orderHistoryAddProductsSelectAll();
	const validator = new OrderHistoryAddProductsValidator();
	new OrderHistoryAddToListBtn(validator);

	// Request and modal code
	events.subscribe(Events.ADD_TO_LIST_BTN_CLICK_END, async () => {
		await orderHistoryRequestAndDisplayModal(
			{
				url: '/ajax/shopping-list/order-history',
			},
			'addToListListsModal',
		);
		orderHistoryAddToListSubmit();
	});

	events.subscribe(Events.ADD_TO_LIST_SUBMIT_END, data => {
		orderHistoryRequestAndDisplayModal(
			{
				url: '/ajax/shopping-list/order-history',
				method: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(data),
			},
			'addToListListsModal',
		);
	});
}
